import {Component} from '@angular/core';
import {UserModel} from "../../models/user.model";
import {Subscription} from "rxjs";
import {UserService} from "../../services/user.service";
import {AuthService} from "../../services/auth.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";
import {TitleService} from "../../services/title.service";
import {TrackingHelperService} from "../../services/tracking-helper.service";
import {GoogleAnalyticsService} from "ngx-google-analytics";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {

  // user!: UserModel | null;
  // userSubs?: Subscription;

  profileUrl!: SafeResourceUrl | null;
  urlSubs?: Subscription;
  titleTranslateSubs?: Subscription;
  lang: string = 'en';

  //TODO later: form to edit user data and show as we want it

  constructor(
    // private userService: UserService,
    private authService: AuthService,
    private translate: TranslateService,
    private titleService: TitleService,
    private sanitizer: DomSanitizer,
    private trackingService: TrackingHelperService,
    private gaService: GoogleAnalyticsService
  ) {
    //setting page title
    this.titleTranslateSubs?.unsubscribe();
    this.titleTranslateSubs = this.translate.stream('ACCOUNT.INFO.TITLE').subscribe(data => {
      this.titleService.setTitle(`Cashier / ${data}`);
    })

    try {
      this.lang = localStorage.getItem("lang") ?? 'en'
    } catch (error){
      console.warn('Error with localStorage, using default lang:', error);
    }

    this.urlSubs?.unsubscribe();
    this.urlSubs = this.authService.cashierUrl.subscribe((url: string | null) => {
        if (url) {
          //disable chat in iframes
          url += '&chatButton=0'

          //add btag and tracker to url
          let bTag = this.trackingService.getBannerTag();
          if (bTag) {
            url += `&btag=${bTag}`
          }
          let t = this.trackingService.getTracker();
          if (t) {
            url += `&t=${t}&tracker=${t}`
          }

          let urlWithParams = this.updateUrlLangParam(this.updateUrlRouteParam(url), this.lang);
          this.profileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithParams);

          if (this.profileUrl){
            this.gaService.event('cashier', undefined, undefined, undefined, undefined,{ cashier_visible: true, ...this.trackingService.getAffiliateOptions() });
          }
        }
    })

    // this is not needed currently TODO when we want to show else than rival iframe
    // this.userSubs?.unsubscribe();
    // this.userSubs = this.userService.userObject.subscribe((u: UserModel | null) => {
    //   this.user = u;
    //   // console.log(this.user)
    // })
  }

  updateUrlLangParam(url: string, lang:string){
    if(url.includes('lang')){
      return url.replace(/lang=[^&]*/, `lang=${lang}`);
    } else {
      return url + `&lang=${lang}`
    }
  }

  updateUrlRouteParam(url: string){
    if(url.includes('route')){
      return url.replace(/route=[^&]*/, 'route=detail');
    } else {
      return url + '&route=detail'
    }
  }



  ngOnDestroy(): void {
    // this.userSubs?.unsubscribe();
    this.urlSubs?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();

    if (this.profileUrl){
      this.gaService.event('cashier', undefined, undefined, undefined, undefined,{ cashier_visible: false, ...this.trackingService.getAffiliateOptions() });
    }

  }

}
